import { IMargin } from "./../../models/IMargin";

export class MarginState {
  symbolMargins: IMargin[] = [];
}
